import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SocketioService {
  socket: Socket;
  peerConnections = {};
  isConnected = false;
  isConnecting = false;
  /**
   * Constructor for SocketioService.
   * Initializes a socket.io client connection to the given environment.socketUrl.
   * The connection is configured to use the websocket transport, autoconnect and reconnect
   * with a maximum of 5 reconnection attempts.
   */
  connectionError: string | null = null;
  reconnectAttempts = 0;
  constructor() {
    this.socket = io(environment.socketUrl, {
      transports: ['websocket'],
      autoConnect: true,
      reconnection: true,
      reconnectionAttempts: Infinity,
    });
    console.log(this.socket);

    this.socket.on('connect', () => {
      if (!this.socket.io.opts.reconnection) {
        this.socket.io.opts.reconnection = true;
      }
      this.isConnected = true;
      this.isConnecting = false;
      this.connectionError = null;
      this.reconnectAttempts = 0;
    });

    this.socket.on('disconnect', (reason) => {
      console.warn(`Socket disconnected: ${reason}`);
      this.isConnected = false;
      this.isConnecting = false;
      this.reconnectAttempts = 0;

      // Do NOT clear connectionError here if it's due to auth failure
      // Only clear if it's a clean disconnect or successful reconnect
      if (reason !== 'io client disconnect') {
        // Only set error if not a manual disconnect
        this.connectionError = `Disconnected: ${reason}`;
      } else {
        this.connectionError = null; // Clear error on clean manual disconnect
      }
    });

    this.socket.on('connect_error', (error) => {
      console.error('Socket connection error:', error.message);
      this.isConnected = false;
      this.isConnecting = false;
      // Specific handling for auth errors
      if (error.message === 'Authentication error') {
        // Match your backend's auth error message
        this.connectionError = 'Authentication failed. Please log in again.';
      } else {
        this.connectionError = `Connection Error: ${error.message}`;
      }
    });

    this.socket.io.on('reconnect_attempt', (attemptNumber) => {
      //   console.log(`SocketService: RECONNECT ATTEMPT: ${attemptNumber}`);
      this.isConnecting = true;
      this.reconnectAttempts = attemptNumber;
      this.connectionError = `Reconnecting... (Attempt ${attemptNumber})`;
    });

    this.socket.io.on('reconnect', (attemptNumber) => {
      //   console.log(
      //     `SocketService: RECONNECTED after ${attemptNumber} attempts.`
      //   );
      this.isConnected = true;
      this.isConnecting = false;
      this.connectionError = null;
      this.reconnectAttempts = 0;
      if (!this.socket.io.opts.reconnection) {
        this.socket.io.opts.reconnection = true;

        //   console.log(
        //     "SocketService: Re-enabled reconnection after successful reconnect."
        //   );
      }
    });

    this.socket.io.on('reconnect_error', (error) => {
      console.error('SocketService: RECONNECTION ERROR:', error.message);
      this.connectionError = `Reconnection Error: ${error.message}`;
    });

    this.socket.io.on('reconnect_failed', () => {
      console.error('SocketService: RECONNECTION FAILED PERMANENTLY.');
      this.isConnected = false;
      this.isConnecting = false;
      this.connectionError =
        'Reconnection failed permanently. Please check network or log in again.';
      this.socket.io.opts.reconnection = false;
      // if (isDevMode())
      //   console.log(
      //     "SocketService: Disabled reconnection after permanent failure."
      //   );
    });
  }
}
